import t from "./defaults.js";
import r from "./underscore.js";
import "./templateSettings.js";
var e = /(.)^/,
  n = {
    "'": "'",
    "\\": "\\",
    "\r": "r",
    "\n": "n",
    "\u2028": "u2028",
    "\u2029": "u2029"
  },
  a = /\\|'|\r|\n|\u2028|\u2029/g;
function o(t) {
  return "\\" + n[t];
}
var u = /^\s*(\w|\$)+\s*$/;
function i(n, i, _) {
  !i && _ && (i = _);
  var s,
    c = RegExp([((i = t({}, i, r.templateSettings)).escape || e).source, (i.interpolate || e).source, (i.evaluate || e).source].join("|") + "|$", "g"),
    l = 0,
    p = "__p+='";
  n.replace(c, function (t, r, e, u, i) {
    return p += n.slice(l, i).replace(a, o), l = i + t.length, r ? p += "'+\n((__t=(" + r + "))==null?'':_.escape(__t))+\n'" : e ? p += "'+\n((__t=(" + e + "))==null?'':__t)+\n'" : u && (p += "';\n" + u + "\n__p+='"), t;
  }), p += "';\n";
  var f = i.variable;
  if (f) {
    if (!u.test(f)) throw Error("variable is not a bare identifier: " + f);
  } else p = "with(obj||{}){\n" + p + "}\n", f = "obj";
  p = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + p + "return __p;\n";
  try {
    s = Function(f, "_", p);
  } catch (t) {
    throw t.source = p, t;
  }
  var j = function j(t) {
    return s.call(this, t, r);
  };
  return j.source = "function(" + f + "){\n" + p + "}", j;
}
export { i as default };